export class TextControl extends Autodesk.Viewing.UI.Control {

    private readonly span: HTMLSpanElement;

    constructor(id: string, options?: any) {
        super(id, options);
        //const div = document.createElement("div");
        (this as any).container.classList.add("textcontrol-div");
        this.span = document.createElement("span");
        this.span.classList.add("textcontrol-span");
        this.span.innerText = "";
        //div.appendChild(span);
        (this as any).container.appendChild(this.span);
    }

    setText(text: string) {
        this.span.innerText = text;
    }

}